import styled from 'styled-components';
import { colors } from 'styles/colors';
import { Button } from '~/components';

export const FilterButtonContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  & > span {
    font-weight: 600;
    font-size: 11px;
    line-height: 150%;
    color: ${({ disabled }) => (disabled ? colors.text['disabled-300'] : colors.text['primary-base'])};
    height: 14px;
  }
`;

export const FilterFieldsContainer = styled.div<{ hasClientInput: boolean }>`
  height: 70px;
  width: 100%;
  background: ${colors.bg['weak-100']};
  border-width: 1px 0;
  border-style: solid;
  border-color: ${colors.stroke['sub-300']};
  padding: 8px 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(182px, 200px));
  gap: 8px;
  align-items: center;
  justify-content: start;
  position: fixed;
  z-index: 10;
  top: 60px;


  @media (max-width: 1478px) {
    height: auto;
  }

  @media (max-width: 768px) {
    ${({ hasClientInput }) => (hasClientInput ? `
      grid-template-columns: repeat(2, 1fr);
    ` : '')}
  }

  @media (min-width: 769px) {
    top: 50px;
  }
`;

export const FilterButton = styled(Button)`
  width: 102px;
  height: 33px;
  padding: 2px;
`;

export const ContainerCollapsedButton = styled.div<{ isCollapsed: boolean }>`
  background-color: ${colors.bg['white-0']};
  margin: -8px -16px;
  padding: 8px 16px;

  ${({ isCollapsed }) => (isCollapsed ? '' : `
    border-bottom: 1px solid ${colors.stroke['sub-300']};
    margin-bottom: 0;
  `)}

  @media (max-width: 768px) {
    grid-column: span 2;
  }
`;
